const conversation={
    namespaced:true,
    state:{
        conversationSelected:'',
        searchModal:false,
        conversationId: '',
        messages: [],
        genericConversations: [],
        participants: []
    },
    getters: {
        getConversationId(state) {
            return state.conversationId;
        },
        getParticipants(state){
            return state.participants;
        },
        getGenericConversations(state){
            return state.genericConversations;
        },
        messagesList(state) {
            return state.messages
        },
        getGenericConversations(state){
            return state.genericConversations;
        }
    },
    mutations:{
        SELECT_CONVERSATION:(state,payload)=>{
            state.conversationSelected=payload
        },
        DESELECT_CONVERSATION: (state) => {
            state.conversationId = ''
            state.messages = []
            state.participants = []
        },
        LOAD_CONVERSATION: (state, payload)=>{
            state.conversationId = payload.conversationId
            state.messages = payload.messages
            state.participants = payload.participants
        },
        UPDATE_GENERIC_CONVERSATIONS_LIST: (state, payload) => {
            state.genericConversations = payload
        },
        SHOW_SEARCH_MODAL:state=>{
            state.searchModal=true;
        },
        CLOSE_MODAL:(state)=>{
            state.searchModal=false;
        }
    },

    actions:{
        selectConversation:({commit},response)=>{
            commit('SELECT_CONVERSATION',response)
        },
        deselectConversation: ({commit}) => {
            commit('DESELECT_CONVERSATION')
        },
        loadConversation: async ({commit, rootState}, conversationId) => {
            const response = await rootState.axios.get('/api/loadConversation', { params: {
                conversationId: conversationId,
                userId: rootState.login.userLoggedIn.userId,
                daysBack: 3
            }})
            
            if (response.data.success){
                const payload = {
                    conversationId: response.data.resBody._id,
                    messages: response.data.resBody.messages,
                    participants: response.data.resBody.participants
                }

                commit('LOAD_CONVERSATION', payload)
            }
        },
        sendMessage: async ({dispatch, rootState}, payload) => {
            const messagePayload = {
                conversationId: payload.conversationId,
                message: payload.message,
                negotiationId: payload.negotiationId,
                counterOfferId: payload.counterOfferId,
                user_id: rootState.login.userLoggedIn.userId
            }

            const response = await rootState.axios.post('/api/sendMessage', messagePayload)
            
            if (response.data.success){
                dispatch('loadConversation', payload.conversationId)
            }
        },
        getGenericConversationsList: async ({dispatch, rootState}) => {
            const userId = rootState.login.userLoggedIn.userId
            const getMessages = await rootState.axios.get('/api/getAllGenericConversations', {params: {userId}})
            
            if (getMessages.data.success){
                const conversationList = Object.assign([], getMessages.data.conversationsData.conversations)
                dispatch('updateGenericConversationsList', conversationList)
            }
        },
        updateGenericConversationsList: ({commit}, payload) => {
            commit('UPDATE_GENERIC_CONVERSATIONS_LIST', payload)
        },
        showSearchModal:({commit})=>{
            commit('SHOW_SEARCH_MODAL')
        },
        closeSearchModal:({commit}) => {
            commit('CLOSE_MODAL')
        }
    }
}

export default conversation